(function () {

  // Mirror of snippets/slider-controls.liquid (chevron-left / chevron-right from
  // snippets/icon.liquid). This path builds its markup by hand, so without this
  // the same component would render with arrows on the Liquid branch and none
  // here. Keep the two in step.
  var SLIDER_CONTROLS_HTML =
    '<div class="slider-controls">'
    + '<div class="slider-controls__progress-wrap">'
    + '<div class="slider-controls__progress-bar"><div class="slider-controls__progress-fill"></div></div>'
    + '</div>'
    + '<div class="slider-controls__arrows">'
    + '<button class="slider-controls__arrow slider-controls__arrow--prev" aria-label="Previous">'
    + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true" focusable="false"><polyline points="15 18 9 12 15 6"/></svg>'
    + '</button>'
    + '<button class="slider-controls__arrow slider-controls__arrow--next" aria-label="Next">'
    + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"/></svg>'
    + '</button>'
    + '</div>'
    + '</div>';

  function buildSlider(slides, el) {
    // Same rule as the Liquid branch: show the controls when the row overflows at
    // either breakpoint (mobile fits fewer, so it decides), and let
    // --fits-desktop hide them above 768px when a desktop row has no overflow.
    var itemsDesktop = parseInt(el.dataset.itemsDesktop, 10) || 4;
    var itemsMobile  = parseInt(el.dataset.itemsMobile, 10) || 2;
    var wrapClasses  = 'product-recommendations__wrap product-recommendations-section__slider';
    if (slides.length <= itemsDesktop) wrapClasses += ' product-recommendations__wrap--fits-desktop';

    el.innerHTML = '<div class="' + wrapClasses + '">'
      + '<div class="product-recommendations__track">' + slides.join('') + '</div>'
      + (slides.length > itemsMobile ? SLIDER_CONTROLS_HTML : '')
      + '</div>';

    var sliderSection = el.closest('.product-recommendations-section');
    if (sliderSection && typeof window.initSlider === 'function') {
      window.initSlider(
        sliderSection,
        '.product-recommendations__track',
        '.product-recommendations__slide',
        'product-recommendations-section'
      );
    }
  }

  function fallbackByVendor(el, vendor, limit, currentUrl, showVendor, showHoverImage) {
    if (!vendor) {
      el.closest('.product-recommendations').hidden = true;
      return;
    }

    // templates/search.rec-rail.liquid renders the same product-card snippet the
    // Liquid branch uses, so this path keeps the stock label (In stock /
    // Pre-Order / Coming Soon), badges and wishlist button. Building the cards
    // here instead could not reproduce them - pre-order state especially, since
    // /products/<handle>.js reports inventory_quantity and inventory_policy null.
    fetch('/search?q=' + encodeURIComponent(vendor) + '&type=product&view=rec-rail')
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var slides = Array.prototype.slice.call(
          doc.querySelectorAll('.product-recommendations__slide')
        );

        // the view cannot read query params, so exclude and slice here
        var currentPath = String(currentUrl || '').split('?')[0];
        slides = slides.filter(function (slide) {
          var link = slide.querySelector('a[href]');
          return !link || link.getAttribute('href').split('?')[0] !== currentPath;
        }).slice(0, parseInt(limit, 10) || 6);

        // ...and neither can it see these two section settings
        slides.forEach(function (slide) {
          if (!showVendor) {
            slide.querySelectorAll('.product-card__vendor').forEach(function (n) { n.remove(); });
          }
          if (!showHoverImage) {
            slide.querySelectorAll('.product-card__img--hover').forEach(function (n) { n.remove(); });
          }
        });

        if (!slides.length) {
          el.closest('.product-recommendations').hidden = true;
          return;
        }

        buildSlider(slides.map(function (s) { return s.outerHTML; }), el);
      })
      .catch(function () {
        el.closest('.product-recommendations').hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
      if (el.querySelector('.product-card:not(.product-card--skeleton)')) return;

      var productId   = el.dataset.productId;
      var sectionId   = el.dataset.sectionId;
      var limit        = el.dataset.limit || 6;
      var displayLimit = el.dataset.displayLimit || 6;
      var vendor      = el.dataset.vendor;
      var currentUrl  = el.dataset.productUrl;
      var showVendor  = el.dataset.showVendor !== '0';
      var showHoverImage = el.dataset.showHoverImage !== '0';

      if (!productId || !sectionId) return;

      var url = '/recommendations/products'
        + '?section_id=' + encodeURIComponent(sectionId)
        + '&product_id=' + encodeURIComponent(productId)
        + '&limit='      + encodeURIComponent(limit)
        + '&intent=related';

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-product-recommendations]');

          // Shopify returned real recommendations — swap in and init slider
          if (inner && inner.querySelector('.product-recommendations__track .product-card:not(.product-card--skeleton)')) {
            el.innerHTML = inner.innerHTML;
            var sliderSection = el.closest('.product-recommendations-section');
            if (sliderSection && typeof window.initSlider === 'function') {
              window.initSlider(
                sliderSection,
                '.product-recommendations__track',
                '.product-recommendations__slide',
                'product-recommendations-section'
              );
            }
            return;
          }

          // No Shopify recommendations yet → fall back to same brand (custom metafield)
          fallbackByVendor(el, vendor, displayLimit, currentUrl, showVendor, showHoverImage);
        })
        .catch(function () {
          fallbackByVendor(el, vendor, displayLimit, currentUrl, showVendor, showHoverImage);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
